import React from 'react';
import {Section} from './CardStyles';
import {styled} from '@mui/material/styles';
import {COLORS, Typography} from '@fupa/fupa-uikit';
import {Paper} from '@mui/material';
import {motion} from 'framer-motion';

const Container = styled('div')`
  padding: 0 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
`;

const MotionWrapper = styled(motion.div)({
  boxSizing: 'border-box',
  width: '30%',
  flex: '30%',
  maxWidth: '30%',
  textAlign: 'center',

  '@media all and (max-width: 800px)': {
    width: '100%',
    flex: '100%',
    maxWidth: '100%',
  },
});

const usps = [
  {
    headline: 'Schnell und Einfach für Jeden',
    content: 'Mühelose Integration der Teamdaten auf eurer Vereinswebseite – ohne aufwendige Eigenentwicklung!',
  },
  {
    headline: 'Einmal integrieren, immer Aktuell',
    content: 'Kostenloser Zugriff auf die aktuellen Daten der Saison – ohne erneute Integration bei Saisonwechsel!',
  },
  {
    headline: 'Vielseitig und Responsiv',
    content:
      'Widgets nach euren Wünschen, optimiert für jedes Gerät - integriert sie nahtlos in eure Seite und verleiht ihnen euer einzigartiges Look & Feel!',
  },
];

const UspHeadline = styled(Typography)`
  &&& {
    color: ${COLORS.fupaSecondary};
    margin-bottom: 0;
  }
`;

const DemoPaper = styled(Paper)(({theme}) => ({
  height: '100%',
  padding: theme.spacing(2),
}));
const TestimonialContent = styled('div')`
  display: flex;
  flex-direction: column;
`;

const UspsCard = () => {
  const Testimonials = usps.map((usp, index) => {
    return (
      <MotionWrapper
        initial={{opacity: 0, scale: 0.5}}
        viewport={{amount: 0.5, once: true}}
        whileInView={{opacity: 1, scale: 1}}
        transition={{delay: index * 0.25, duration: 0.5}}>
        <DemoPaper key={index} elevation={3}>
          <TestimonialContent>
            <UspHeadline variant={'headline2'} component={'h3'}>
              {usp.headline}
            </UspHeadline>
            <Typography variant={'subheading'} component={'p'}>
              {usp.content}
            </Typography>
          </TestimonialContent>
        </DemoPaper>
      </MotionWrapper>
    );
  });

  return (
    <Section backgroundColor={COLORS.lightGrey}>
      <Container>{Testimonials}</Container>
    </Section>
  );
};

export default UspsCard;
